import type { ReactNode } from 'react';
import { Menu } from 'lucide-react';
import { navItems } from '../lib/content';

interface PublicLayoutProps {
  children: ReactNode;
}

export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="site-shell">
      <header className="site-nav">
        <a className="site-brand" href="/#top" aria-label="Society of Mystics home">
          <img src="/assets/som-emblem.svg" alt="" />
          <span>
            <strong>Society of Mystics</strong>
            <small>Experience - Transformation - Unity</small>
          </span>
        </a>
        <nav aria-label="Main navigation">
          {navItems.map((item) => (
            <a key={item.label} href={item.href} target={item.external ? '_blank' : undefined} rel={item.external ? 'noreferrer' : undefined}>
              {item.label}
            </a>
          ))}
          <a href="/admin">Login</a>
        </nav>
        <button className="nav-menu" type="button" aria-label="Open navigation">
          <Menu size={22} />
        </button>
      </header>
      {children}
      <footer className="site-footer">
        <div>© {new Date().getFullYear()} Society of Mystics</div>
        <div>Experience - Transformation - Unity</div>
      </footer>
    </div>
  );
}
